import client from './client';

export const articlesApi = {
  list: (limit = 20, offset = 0) => client.get(`/articles?limit=${limit}&offset=${offset}`, { auth: false }),
  getBySlug: (slug) => client.get(`/articles/${slug}`, { auth: false }),

  // Back Office
  adminList: (limit = 100, offset = 0) => client.get(`/admin/articles?limit=${limit}&offset=${offset}`),
  create: (data) => client.post('/admin/articles', data),
  update: (id, data) => client.put(`/admin/articles/${id}`, data),
  remove: (id) => client.delete(`/admin/articles/${id}`),
};
